import React, { useState, useEffect } from "react";
import { Phone, Mail } from "lucide-react";
import { faInstagram , faFacebookF , faYoutube } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSquareWhatsapp } from "@fortawesome/free-brands-svg-icons";
import "./Navbar.css";
import logo from "../assets/bca logo.webp";

const IvyWorldHome = () => {
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <>
      <div className="ivy-world-home">

       {/* TOP BAR */}
        <div className="bca-top-bar">
          <div className="bca-top-bar-content">
            <div className="bca-contact-info">
              <a href="tel:0154- 2460807">
                <Phone size={16} /> 0154- 2460807, 2461807
              </a>
              <a href="mailto:admin@bihanichildrensacademy.com">
                <Mail size={16} /> admin@bihanichildrensacademy.com
              </a>
            </div>
             <div className="bca-social-icons">
                      <a className="social-icon insta" href="https://www.instagram.com/bihani_childrens_academy?igsh=MWVpcHo0aWptc2pydA==" aria-label="Instagram">
                        <FontAwesomeIcon icon={faInstagram} />
                      </a>
                      <a className="social-icon facebook" href="https://www.facebook.com/bcasgnr/" aria-label="Facebook">
                        <FontAwesomeIcon icon={faFacebookF} />
                      </a>
                      <a className="social-icon youtube" href="https://www.youtube.com/channel/UCkgoZqhiORl0EWBTHf3_2Qw" aria-label="YouTube">
                        <FontAwesomeIcon icon={faYoutube} />
                      </a>
                    </div>
          </div>
        </div>

        {/* HEADER */}
        <header className="bca-header">
          <div className="bca-header-content">
            
            {/* LOGO SECTION */}
            <div className="bca-logo">
              <img src={logo} alt="BCA Logo" className="bca-logo-img" />
              <div className="bca-logo-text">
                <h1>Bihani Children's Academy</h1>
              </div>
            </div>

            {/* MOBILE MENU TOGGLE */}
            <button 
              className="ivy-mobile-menu-btn"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              aria-label="Toggle Menu"
            >
              <span className={`hamburger ${mobileMenuOpen ? 'active' : ''}`}>
                <span></span>
                <span></span>
                <span></span>
              </span>
            </button>

            {/* NAVIGATION */}
            <nav className={`ivy-nav ${mobileMenuOpen ? 'mobile-open' : ''}`}>

              {/* HOME */}
              <div
                className="ivy-nav-item"
                onMouseEnter={() => setActiveDropdown("Home")}
                onMouseLeave={() => setActiveDropdown(null)}
                onClick={() => setMobileMenuOpen(false)}
              >
                <a href="/" className="ivy-nav-link active">Home</a>
              </div>

              {/* ABOUT BCA */}
              <div
                className="ivy-nav-item"
                onMouseEnter={() => setActiveDropdown("About BCA")}
                onMouseLeave={() => setActiveDropdown(null)}
              >
                <a 
                  href="#" 
                  className="ivy-nav-link"
                  onClick={(e) => {
                    e.preventDefault();
                    if (window.innerWidth <= 768) {
                      setActiveDropdown(activeDropdown === "About BCA" ? null : "About BCA");
                    }
                  }}
                >
                  About BCA <span className="ivy-dropdown-arrow">▼</span>
                </a>

                {activeDropdown === "About BCA" && (
                  <div className="dropdown-menu">
                    <a href="/who" className="dropdown-item" onClick={() => setMobileMenuOpen(false)}>Who We Are</a>
                    <a href="/president" className="dropdown-item" onClick={() => setMobileMenuOpen(false)}>Message from President</a>
                    <a href="/vicepresident" className="dropdown-item" onClick={() => setMobileMenuOpen(false)}>Message from vice President</a>
                    <a href="/principal" className="dropdown-item" onClick={() => setMobileMenuOpen(false)}>Message from Principal</a>
                    <a href="/BCA Managing Committee New (2).pdf" className="dropdown-item" onClick={() => setMobileMenuOpen(false)}>Management Committee</a>
                  </div>
                )}
              </div>

              {/* ACADEMICS — MULTI COLUMN */}
              <div
                className="ivy-nav-item large-dropdown"
                onMouseEnter={() => setActiveDropdown("Academics")}
                onMouseLeave={() => setActiveDropdown(null)}
              >
                <a 
                  href="#" 
                  className="ivy-nav-link"
                  onClick={(e) => {
                    e.preventDefault();
                    if (window.innerWidth <= 768) {
                      setActiveDropdown(activeDropdown === "Academics" ? null : "Academics");
                    }
                  }}
                >
                  Academics <span className="ivy-dropdown-arrow">▼</span>
                </a>

                {activeDropdown === "Academics" && (
                  <div className="dropdown-menu">
                    <a href="/booklist.pdf" className="dropdown-item" onClick={() => setMobileMenuOpen(false)}>Book List</a>
                    <a href="/ACTIVITY CALENDER 2026-27 - 060426 (2).pdf" className="dropdown-item" onClick={() => setMobileMenuOpen(false)}>Activity Calendar</a>
                    <a href="/parent" className="dropdown-item" onClick={() => setMobileMenuOpen(false)}>Parent Guidelines</a>
                    <a href="/studentguid" className="dropdown-item" onClick={() => setMobileMenuOpen(false)}>Student Guidelines</a>
                    <a href="/result" className="dropdown-item" onClick={() => setMobileMenuOpen(false)}>Results</a>
                    <a href="/admin" className="dropdown-item" onClick={() => setMobileMenuOpen(false)}>Administration</a>
                    <a href="/cbse" className="dropdown-item" onClick={() => setMobileMenuOpen(false)}>CBSE Disclosure</a>
                    <a href="/nonteach" className="dropdown-item" onClick={() => setMobileMenuOpen(false)}>Admin Staff</a>
                    <a href="/staff" className="dropdown-item" onClick={() => setMobileMenuOpen(false)}>Teaching Staff</a>
                    <a href="/transfer" className="dropdown-item" onClick={() => setMobileMenuOpen(false)}>TC</a>
                    <a href="/Recognition Certificate Under RTE Act.2009.pdf" className="dropdown-item" onClick={() => setMobileMenuOpen(false)}>RTE Affiliation</a>
                    <a href="/rte.pdf" className="dropdown-item" onClick={() => setMobileMenuOpen(false)}>RTE admission Time frame 2025-26</a>
                  </div>
                )}
              </div>

              {/* CBSE Disclouser */}
              <div className="ivy-nav-item" onClick={() => setMobileMenuOpen(false)}>
                <a href="/cbse" className="ivy-nav-link">CBSE Disclosure</a>
              </div>

              {/* FEE STRUCTURE */}
              <div className="ivy-nav-item" onClick={() => setMobileMenuOpen(false)}>
                <a href="/Fee-2026 (2).pdf" className="ivy-nav-link">Fee Structure</a>
              </div>
              
              {/* FEE STRUCTURE */}
              <div className="ivy-nav-item" onClick={() => setMobileMenuOpen(false)}>
                <a href="/admission" className="ivy-nav-link">Admissions</a>
              </div>

              {/* FACILITIES — MULTI COLUMN */}
              <div
                className="ivy-nav-item large-dropdown"
                onMouseEnter={() => setActiveDropdown("Facilities")}
                onMouseLeave={() => setActiveDropdown(null)}
              >
                <a 
                  href="#" 
                  className="ivy-nav-link"
                  onClick={(e) => {
                    e.preventDefault();
                    if (window.innerWidth <= 768) {
                      setActiveDropdown(activeDropdown === "Facilities" ? null : "Facilities");
                    }
                  }}
                >
                  Facilities <span className="ivy-dropdown-arrow">▼</span>
                </a>

                {activeDropdown === "Facilities" && (
                  <div className="dropdown-menu">
                    <a href="/robotic" className="dropdown-item" onClick={() => setMobileMenuOpen(false)}>AI & Robotics Lab</a>
                    <a href="/smartedu" className="dropdown-item" onClick={() => setMobileMenuOpen(false)}>Smart Class Education</a>
                    <a href="/language" className="dropdown-item" onClick={() => setMobileMenuOpen(false)}>Language Lab</a>
                    <a href="/scilab" className="dropdown-item" onClick={() => setMobileMenuOpen(false)}>Science Lab</a>
                    <a href="/math" className="dropdown-item" onClick={() => setMobileMenuOpen(false)}>Maths Lab</a>
                    <a href="/complab" className="dropdown-item" onClick={() => setMobileMenuOpen(false)}>Computer Lab</a>
                    <a href="/library" className="dropdown-item" onClick={() => setMobileMenuOpen(false)}>Library</a>
                    <a href="/digital" className="dropdown-item" onClick={() => setMobileMenuOpen(false)}>BCA E-Library</a>
                    <a href="/artcraft" className="dropdown-item" onClick={() => setMobileMenuOpen(false)}>Art & Craft</a>
                    <a href="/music" className="dropdown-item" onClick={() => setMobileMenuOpen(false)}>Music Lab</a>
                  </div>
                )}
              </div>

              {/* ACTIVITIES */}
              <div
                className="ivy-nav-item"
                onMouseEnter={() => setActiveDropdown("Activities")}
                onMouseLeave={() => setActiveDropdown(null)}
              >
                <a 
                  href="#" 
                  className="ivy-nav-link"
                  onClick={(e) => {
                    e.preventDefault();
                    if (window.innerWidth <= 768) {
                      setActiveDropdown(activeDropdown === "Activities" ? null : "Activities");
                    }
                  }}
                >
                  Activities <span className="ivy-dropdown-arrow">▼</span>
                </a>

                {activeDropdown === "Activities" && (
                  <div className="dropdown-menu">
                    <a href="/ceremony" className="dropdown-item" onClick={() => setMobileMenuOpen(false)}>Ceremony</a>
                    <a href="/alumni" className="dropdown-item" onClick={() => setMobileMenuOpen(false)}>Alumni Facilation </a>
                    <a href="/sports" className="dropdown-item" onClick={() => setMobileMenuOpen(false)}>Sports</a>
                    <a href="/events" className="dropdown-item" onClick={() => setMobileMenuOpen(false)}>Events</a>
                    <a href="/fete" className="dropdown-item" onClick={() => setMobileMenuOpen(false)}>Fete</a>
                    <a href="/science" className="dropdown-item" onClick={() => setMobileMenuOpen(false)}>Science Exhibition</a>
                  </div>
                )}
              </div>

              {/* CONTACT */}
              <div className="ivy-nav-item" onClick={() => setMobileMenuOpen(false)}>
                <a href="/contact" className="ivy-nav-link">Contact Us</a>
              </div>

            </nav>
          </div>
        </header>

        {/* WHATSAPP FLOAT BUTTON */}
        <a
          href="https://wa.me/919625416068 "
          className="ivy-whatsapp-btn"
          target="_blank"
          rel="noopener noreferrer"
        >
         <FontAwesomeIcon icon={faSquareWhatsapp} />
        </a>
      </div>

 
    </>
  );
};

export default IvyWorldHome;